import { PAGES } from "@/internals/constants/pages";
import { StatsFormFields } from "./stats-block";
import { FACILITIES } from "@/data/shared/facilities";

const structure = {
  page: PAGES.QR_EVENT,
  metaTitle: "meta_title",
  metaDescription: "meta_description",
  title: "title",
  formFields: [
    {
      component: "Accordion",
      title: "name_title",
      className: "qrForm",
      formFields: [
        {
          component: "InputLib",
          type: "text",
          placeholder: "name_placeholder",
          errorMessage: [{ rule: "maxLength", message: "name_min_length" }],
          name: "qrName",
          data_qa: "qr-event-name-input",
        },
      ],
    },
    {
      component: "Accordion",
      title: "theme_picker_title",
      formFields: [
        {
          component: "ThemePicker",
          labelPrimary: "theme_picker_label_primary",
          labelSecondary: "theme_picker_label_secondary",
          id: "qrEventThemePicker",
          name: "qrEventThemePicker",
          data_qa: "qr-event-theme-picker",
        },
      ],
    },
    {
      component: "Accordion",
      title: "information_title",
      id: "qrEventInformation",
      className: "qrEventInformation",
      formFields: [
        {
          component: "div",
          className: "u-flex-full",
          formFields: [
            {
              component: "ImageUpload",
              title: "information_image_label",
              id: "qrEventInformationImage",
              showEditor: "16/9",
              name: "logoUrl",
              data_qa: "qr-event-image-upload",
            },
          ],
        },
        {
          component: "InputLib",
          type: "text",
          name: "infoTitle",
          data_qa: "qr-event-title-input",
          label: "information_title_label",
          placeholder: "information_title_placeholder",
          errorMessage: [
            {
              rule: "minLength",
              message: "information_title_min_length",
            },
            {
              rule: "maxLength",
              message: "information_title_max_length",
            },
          ],
        },
        {
          component: "InputLib",
          type: "text",
          name: "infoDescription",
          data_qa: "qr-event-description-input",
          label: "information_description_label",
          placeholder: "information_description_placeholder",
          errorMessage: [
            {
              rule: "maxLength",
              message: "information_description_max_length",
            },
          ],
        },
        {
          component: "div",
          className: "button-wrapper",
          formFields: [
            {
              component: "InputLib",
              type: "text",
              name: "infoActionTitle",
              data_qa: "qr-event-button-text-input",
              label: "information_button_label",
              placeholder: "information_button_placeholder",
              errorMessage: [
                {
                  rule: "maxLength",
                  message: "information_button_max_length",
                },
              ],
            },
            {
              component: "InputLib",
              type: "text",
              name: "infoActionUrl",
              data_qa: "qr-event-button-url-input",
              label: "information_url_label",
              placeholder: "information_url_placeholder",
              errorMessage: [{ rule: "pattern", message: "invalid_url_start" }],
            },
          ],
        },
      ],
    },
    {
      component: "Accordion",
      title: "time_title",
      className: "event-time",
      formFields: [
        {
          component: "EventDateTime",
          id: "eventDateTime",
          name: "eventDateTime",
        },
      ],
    },
    {
      component: "Accordion",
      title: "preview_location",
      className: "qrEventLocation",
      formFields: [
        {
          component: "div",
          className: "address-numeration-wrapper",
          formFields: [
            {
              component: "InputLib",
              type: "text",
              label: "location_address_label",
              placeholder: "location_address_placeholder",
              errorMessage: [
                {
                  rule: "maxLength",
                  message: "location_address_max_length",
                },
              ],
              name: "locationAddress",
              data_qa: "qr-event-address-input",
            },
            {
              component: "div",
              className: "numeration-wrapper",
              formFields: [
                {
                  component: "InputLib",
                  type: "text",
                  label: "location_number_label",
                  placeholder: "location_number_placeholder",
                  errorMessage: [
                    {
                      rule: "maxLength",
                      message: "location_number_max_length",
                    },
                  ],
                  name: "locationNumeration",
                  data_qa: "qr-event-numeration-input",
                },
                {
                  component: "InputLib",
                  type: "text",
                  label: "location_zip_code_label",
                  placeholder: "location_zip_code_placeholder",
                  errorMessage: [
                    {
                      rule: "maxLength",
                      message: "location_zip_code_max_length",
                    },
                  ],
                  name: "locationPostalCode",
                  data_qa: "qr-event-zip-code-input",
                },
              ],
            },
          ],
        },
        {
          component: "div",
          className: "address-state",
          formFields: [
            {
              component: "InputLib",
              type: "text",
              label: "location_city_label",
              placeholder: "location_city_placeholder",
              errorMessage: [
                {
                  rule: "maxLength",
                  message: "location_city_max_length",
                },
              ],
              name: "locationCity",
              data_qa: "qr-event-city-input",
            },
            {
              component: "InputLib",
              type: "text",
              label: "location_state_label",
              placeholder: "location_state_placeholder",
              errorMessage: [
                {
                  rule: "maxLength",
                  message: "location_state_max_length",
                },
              ],
              name: "locationState",
              data_qa: "qr-event-state-input",
            },
            {
              component: "InputLib",
              type: "text",
              label: "Location_country_label",
              placeholder: "location_country_placeholder",
              errorMessage: [
                {
                  rule: "maxLength",
                  message: "location_country_max_length",
                },
              ],
              name: "locationCountry",
              data_qa: "qr-event-country-input",
            },
          ],
        },
      ],
    },
    {
      component: "Accordion",
      title: "preview_organizer",
      id: "qrEventOrganizerInformation",
      className: "qrEventOrganizerInformation",
      formFields: [
        {
          component: "div",
          className: "fullName-wrapper",
          formFields: [
            {
              component: "InputLib",
              type: "text",
              label: "organizer_contact_name_label",
              placeholder: "organizer_contact_name_placeholder",
              errorMessage: [
                {
                  rule: "maxLength",
                  message: "organizer_contact_name_max_length",
                },
              ],
              name: "organizerName",
              data_qa: "qr-event-fullName-input",
            },
            {
              component: "InputLib",
              type: "text",
              label: "organizer_phone_label",
              placeholder: "organizer_phone_placeholder",
              errorMessage: [{ rule: "maxLength", message: "organizer_phone_max_length" }],
              name: "organizerPhone",
              data_qa: "qr-event-phone-input",
            },
          ],
        },
        {
          component: "div",
          className: "fullName-wrapper",
          formFields: [
            {
              component: "InputLib",
              type: "text",
              label: "organizer_email_label",
              placeholder: "organizer_email_placeholder",
              errorMessage: [{ rule: "pattern", message: "invalid_email" }],
              name: "organizerEmail",
              data_qa: "qr-event-email-input",
            },
            {
              component: "InputLib",
              type: "text",
              label: "organizer_website_label",
              placeholder: "organizer_website_placeholder",
              name: "organizerWebsite",
              errorMessage: [{ rule: "pattern", message: "invalid_url_start" }],
              data_qa: "qr-event-website-input",
            },
          ],
        },
        {
          component: "TextAreaLib",
          type: "text",
          resize: "none",
          rows: 5,
          label: "organizer_about_us_label",
          placeholder: "organizer_about_us_placeholder",
          errorMessage: [
            {
              rule: "maxLength",
              message: "organizer_about_us_max_length",
            },
          ],
          name: "organizerAbout",
          data_qa: "qr-event-about-us-input",
        },
      ],
    },
    {
      component: "Accordion",
      title: "preview_facilities",
      className: "qrEventFacilities",
      formFields: [
        {
          component: "Picker",
          id: "qrEventFacilitiesPicker",
          multiple: true,
          className: "Picker__list-background",
          options: FACILITIES,
          name: "facilities",
          data_qa: "qr-event-name-picker",
          selector: "icon",
        },
      ],
    },
    {
      component: "Accordion",
      title: "stats_title",
      subtitle: "stats_subtitle",
      className: "qrForm",
      formFields: StatsFormFields(),
    },
  ],
  layoutTranslations: {
    eventPreviewTime: "preview_time",
    eventPreviewTimeStart: "preview_time_start",
    eventPreviewTimeEnd: "preview_time_end",
    eventPreviewTimeSchedule: "preview_time_schedule",
    eventPreviewAllDay: "preview_all_day",
    eventPreviewLocation: "preview_location",
    eventPreviewOrganizer: "preview_organizer",
    eventPreviewFacilities: "preview_facilities",
    eventPreviewOrganizerName: "preview_organizer_name",
    eventPreviewOrganizerPhone: "preview_organizer_phone",
    eventPreviewOrganizerEmail: "preview_organizer_email",
    eventPreviewOrganizerWebsite: "preview_organizer_website",
    eventPreviewOrganizerAbout: "preview_organizer_about",
    eventPreviewEventName: "preview_event_name",
  },
};

export default structure;
